module.exports = __webpack_public_path__ + "img/3.f7991ca3.png";